module.exports = __webpack_public_path__ + "img/telehealth_video-call.82a64bd6.svg";